import { formConstants } from '../constants';
import { formService } from '../../services';

export const formActions = {
  contactsList,
  getContact,
  branchRequestsList,
  getBranchRequest,
  jobsList,
  getJob
}

/*
ACTION: Contacts List
*/
function contactsList(pageID, perPage, searchInput = '') {
  return dispatch => {
    dispatch(request());
    return formService.contactsList(pageID, perPage, searchInput)
      .then(
        response => {
          dispatch(success(response.data.body.contactuses, response.data.body.data.total));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: formConstants.CONTACTS_GETALL_REQUEST } }
  function success(items, total) { return { type: formConstants.CONTACTS_GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: formConstants.CONTACTS_GETALL_FAILURE, error } }
}

/*
ACTION: Get Contact By ID
*/
function getContact(contactID) {
  return dispatch => {
    dispatch(request());
    return formService.getContact(contactID)
      .then(
        response => {
          // console.log(response);
          dispatch(success(response.data.body));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: formConstants.CONTACTS_GET_REQUEST } }
  function success(item) { return { type: formConstants.CONTACTS_GET_SUCCESS, item } }
  function failure(error) { return { type: formConstants.CONTACTS_GET_FAILURE, error } }
}

/*
ACTION: Branch Requests List
*/
function branchRequestsList(pageID, perPage, searchInput = '') {
  return dispatch => {
    dispatch(request());
    return formService.branchRequestsList(pageID, perPage, searchInput)
      .then(
        response => {
          // console.log(response);
          dispatch(success(response.data.body.requests, response.data.body.data.total));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: formConstants.BRANCH_REQUESTS_GETALL_REQUEST } }
  function success(items, total) { return { type: formConstants.BRANCH_REQUESTS_GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: formConstants.BRANCH_REQUESTS_GETALL_FAILURE, error } }
}

/*
ACTION: Get Branch Request By ID
*/
function getBranchRequest(branchRequestID) {
  return dispatch => {
    dispatch(request());
    return formService.getBranchRequest(branchRequestID)
      .then(
        response => {
          // console.log(response);
          dispatch(success(response.data.body));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: formConstants.BRANCH_REQUESTS_GET_REQUEST } }
  function success(item) { return { type: formConstants.BRANCH_REQUESTS_GET_SUCCESS, item } }
  function failure(error) { return { type: formConstants.BRANCH_REQUESTS_GET_FAILURE, error } }
}

/*
ACTION: Jobs List
*/
function jobsList(pageID, perPage, searchInput = '') {
  return dispatch => {
    dispatch(request());
    return formService.jobsList(pageID, perPage, searchInput)
      .then(
        response => {
          console.log(response);
          dispatch(success(response.data.body.resumes, response.data.body.data.total));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: formConstants.JOBS_GETALL_REQUEST } }
  function success(items, total) { return { type: formConstants.JOBS_GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: formConstants.JOBS_GETALL_FAILURE, error } }
}

/*
ACTION: Get Job By ID
*/
function getJob(contactID) {
  return dispatch => {
    dispatch(request());
    return formService.getJob(contactID)
      .then(
        response => {
          // console.log(response);
          dispatch(success(response.data.body));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: formConstants.JOBS_GET_REQUEST } }
  function success(item) { return { type: formConstants.JOBS_GET_SUCCESS, item } }
  function failure(error) { return { type: formConstants.JOBS_GET_FAILURE, error } }
}
